import { Outlet } from 'react-router-dom';
import Header from '../header/Header';

function RouteWithHeader() {
	return (
		<>
			<Header />
			<Outlet />
		</>
	);
}

export default RouteWithHeader;
